import React from 'react';

import cn from 'classnames';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Typography from '@material-ui/core/Typography';

import { getAvailableShifts, displayShift, Shift } from 'services/helpers/shift';
import { useRegion } from 'common/hooks/region';
import RefreshButton from '../RefreshButton';

interface Props {
  selectedShift: Shift;
  changeSelectedShift: (shift: Shift) => void;
  classes: Record<string, string>;
}

export const ShiftPicker: React.FC<Props> = (props) => {
  const region = useRegion();
  const hasMultipleShifts = React.useMemo(() => region.shifts.length > 1, [region]);
  const handleShift = (_: React.MouseEvent<HTMLElement>, shift: Shift) =>
    shift && props.changeSelectedShift(shift);
  const availableShifts = React.useMemo(
    () => getAvailableShifts(hasMultipleShifts ? 4 : 2, region),
    [region, hasMultipleShifts]
  );

  const { changeSelectedShift } = props;

  React.useEffect(() => {
    if (availableShifts[0]) {
      changeSelectedShift(availableShifts[0]);
    }
  }, [availableShifts, changeSelectedShift]);

  const { selectedShift, classes } = props;
  return (
    <div className={classes.container}>
      <ToggleButtonGroup
        value={selectedShift}
        exclusive
        onChange={handleShift}
        classes={{ root: classes.buttonGroup }}
      >
        {availableShifts.map((shift) => (
          <ToggleButton
            disableRipple
            value={shift}
            key={shift.day + shift.shift}
            classes={{ root: classes.root, selected: classes.selected }}
          >
            <Typography
              variant="caption"
              className={cn(classes.label, {
                [classes.labelSelected]: selectedShift === shift,
              })}
            >
              {displayShift(shift, !hasMultipleShifts)}
            </Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <div className={classes.reload}>
        <RefreshButton />
      </div>
    </div>
  );
};
